var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isDismissed)?_c('gl-banner',{ref:"banner",attrs:{"data-testid":"invite-members-banner","title":_vm.$options.i18n.title,"button-text":_vm.$options.i18n.button_text,"svg-path":_vm.svgPath},on:{"close":_vm.handleClose,"primary":_vm.openModal}},[_c('p',[_vm._v(_vm._s(_vm.$options.i18n.body))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }